import EndpointsBase from '../base';

enum EndpointsMonitoring {
  BaseMonitoring = EndpointsBase.BaseMonitoring,
  ShipmentMonitoring = `${EndpointsBase.BaseMonitoring}/shipment-monitoring`,
  MonitoringList = `${EndpointsBase.BaseMonitoring}/monitoring-list`,
}

export default EndpointsMonitoring;
